import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      id: _ctx.POPUP_ROOT_ID,
      class: "popup-root"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1)
  ]))
}